import { privateRequest } from "@/services/axios"

const ENDPOINTS = { 
    PRODUCT_CATALOGUE_lIST : "/api/ManufactureProducts"
}

const getProductCatalogueList = async (params : any) => {
    const res = await privateRequest.get(`${ENDPOINTS.PRODUCT_CATALOGUE_lIST}?from=${params.from}&to=${params.to}&search=${params.search}`);
    return res.data;
}

const productCatalogueService = {
    getProductCatalogueList
}

export default productCatalogueService;